import React from 'react';
import { logAuditEvent } from '../../lib/telemetry/auditTelemetry';

/**
 * Emits a one-shot `dashboard-section-viewed` event when the section first
 * enters viewport.
 */
export function useSectionViewedTelemetry(sectionId: string) {
  const ref = React.useRef<HTMLElement | null>(null);
  const hasLogged = React.useRef(false);

  React.useEffect(() => {
    const node = ref.current;
    if (!node || hasLogged.current || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.some((entry) => entry.isIntersecting);
      if (!visible || hasLogged.current) return;
      hasLogged.current = true;
      logAuditEvent({
        type: 'dashboard-section-viewed',
        payload: { sectionId },
      });
      observer.disconnect();
    }, { threshold: 0.2 });
    observer.observe(node);
    return () => observer.disconnect();
  }, [sectionId]);

  return ref;
}
